"use client";
import React from "react";
import "./ContactHero.scss";
import { motion } from "framer-motion";

const ContactHero = () => {
  return (
    <section className="section contactHero">
      <article className="contactHero__container container">
        <div className="contactHero__container--header">
          <div className="contactHero__container--header-title">
            <motion.h3
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              Schedule a
            </motion.h3>
            <motion.h2
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 1, delay: 0.4 }}
            >
              — meeting...
            </motion.h2>
          </div>

          <motion.p
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1.3, delay: 1.2 }}
            className="contactHero__container--header-subtitle"
          >
            Ready to do big things? Fill out our form below
            <br /> and tell us about your vision.
          </motion.p>
        </div>
      </article>
    </section>
  );
};

export default ContactHero;
